// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title{text-align:center;color:#00008b}.components-container{display:flex;position:absolute;flex-direction:column;margin-left:2px;width:99%;height:98%}html{height:100%}body{min-height:100%}.inputline{display:flex;align-items:center;float:right}.json-tree-table{height:100%}#icons{float:right}", ""]);
// Exports
module.exports = exports;
